import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from '../baseApiService';
import { AuthenticationService } from '../../auth/authentication-service';
import { Customer } from './customer';
import { CustomerSearchQuery } from './customerSearchQuery';

@Injectable({
  providedIn: 'root'
})
export class CustomerApiService extends BaseApiService {
  constructor(http: HttpClient, authService: AuthenticationService) {
    super(http, authService);
  }

  getCustomer(customerId: string): Observable<Customer> {
    return this.http.get<Customer>(`${this.apiUrl}/api/v6/customers/${customerId}`).pipe(
      catchError(this.handleError<Customer>('getCustomer', undefined))
    );
  }

  searchCustomers(searchQuery: CustomerSearchQuery, pagingKey: string | null, limit: number): Observable<Customer[]> {
    return this.http.get<Customer[]>(this.getSearchUrl(searchQuery, pagingKey, limit)).pipe(
      catchError(this.handleError<Customer[]>('searchCustomer', undefined))
    );
  }

  private getSearchUrl(searchQuery: CustomerSearchQuery, pagingKey: string | null, limit: number) {
    const searchQueryText = this.getSearchQueryText(searchQuery);

    if (pagingKey) {
      return `${this.apiUrl}/api/v6/customers/search?start=${pagingKey}&limit=${limit}&searchInGravity=${searchQuery.searchInGravity}&${searchQueryText}`;
    }
    else {
      return `${this.apiUrl}/api/v6/customers/search?limit=${limit}&searchInGravity=${searchQuery.searchInGravity}&${searchQueryText}`;
    }
  }

  private getSearchQueryText(searchQuery: CustomerSearchQuery) {
    const queryParams: string[] = [];

    if (searchQuery.ids) {
      queryParams.push(`ids=${searchQuery.ids}`);
    }
    if (searchQuery.name) {
      queryParams.push(`name=${searchQuery.name}`);
    }
    if (searchQuery.country) {
      queryParams.push(`country=${searchQuery.country}`);
    }

    return queryParams.join('&');
  }
}
